<template>
  <bottom-bar-layout v-if="loaded"
                     class="million-read-article-detail"
                     show-bar
                     :shadow="false"
                     bar-background="transparent"
                     :bar-height="170"
  >
    <div class="million-read-article-detail-container"
         :class="{
           'article-detail': pageType === 'article',
           'topic-detail': pageType === 'topic',
         }"
    >
      <div v-if="pageType !== 'topic' && render.showTitle"
           class="million-read-article-detail-title"
      >
        {{ article.title }}
      </div>
      <div v-if="pageType !== 'topic' && render.showPublishedTime"
           class="million-read-article-detail-date"
      >
        {{ article.publishedTime|formatTime('yyyy年MM月dd日') }}
      </div>
      <rich-text class="million-read-article-detail-content"
                 :content="article.content"
      />
    </div>
    <div v-if="render.showReview"
         class="million-read-article-detail-review"
         @click.stop="handleResetComment"
    >
      <div class="million-read-article-detail-review-header">
        <div class="million-read-article-detail-review-header-title">精选留言</div>
      </div>
      <template v-if="reviewList.length !== 0">
        <ym-loadmore v-model="loading"
                     :finished="allLoad"
                     @load="fetchReviewExplore"
        >
          <div class="million-read-article-detail-review-list">
            <div class="million-read-article-detail-review-list-item"
                 v-for="(item, index) in reviewList"
                 :key="index"
            >
              <div class="million-read-article-detail-review-list-item-container">
                <img class="million-read-article-detail-review-list-item-avatar"
                     :src="item.user.avatar"
                     alt=""
                     v-ym-report:MILLION_VIP_USER_HOMEPAGE_ENTER_TOPIC_COMMENT_CLICK="{
                       topicId: articleId,
                       commentId: item.id,
                     }"
                     @click="handleToUserCenter(item.user.id)"
                />
                <div class="million-read-article-detail-review-list-item-info">
                  <div class="million-read-article-detail-review-list-item-user-name">
                    <span>{{ item.user.name }}</span>
                    <ym-img v-if="item.user.isVip"
                            class="vip-icon"
                            :src="require('@/assets/img/vip/review_vip_icon.png')"
                    />
                  </div>
                  <div v-if="item.quote"
                       class="million-read-article-detail-review-list-item-quote-container"
                  >
                    <div class="ym-two-line-ellipsis">
                      <span>回复 {{ item.quote.user.name }} </span>{{ item.quote.content }}
                    </div>
                  </div>
                  <div class="million-read-article-detail-review-list-item-content">
                    {{ item.content }}
                  </div>
                  <div class="million-read-article-detail-review-list-item-action-bar">
                    <div class="million-read-article-detail-review-list-item-action-bar-date">
                      <template v-if="fetchYear(item.createdTime)">
                        {{ item.createdTime | formatTime('MM-dd HH:ii') }}
                      </template>
                      <template v-else>
                        {{ item.createdTime | formatTime('yyyy-MM-dd HH:ii') }}
                      </template>
                    </div>
                    <div class="right-block">
                      <div class="like-block"
                           @click="handleLikeComment(item, '')"
                      >
                        <ym-icon v-if="item.like.liked"
                                 class="icon active"
                                 name="yidianzan"
                        />
                        <ym-icon v-else
                                 class="icon"
                                 name="dianzan"
                        />
                        <div v-if="item.like.count !== 0"
                             class="count"
                        >
                          {{ item.like.count }}
                        </div>
                      </div>
                      <ym-icon class="comment-icon"
                               name="comment"
                               @click.stop="handleReplyComment(item)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ym-loadmore>
      </template>
      <empty-page v-else
                  class="empty-page"
                  type="message"
                  hint="看看下面~ 来留言吧"
      />
    </div>
    <template #tabbar>
      <consult-bar v-if="render.consultBar && render.consultBar.show"
                   :color="render.consultBar.color"
                   :tel="render.consultBar.tel"
                   :wechat-url="render.consultBar.wechatUrl"
      />
      <ym-tabbar v-if="render.showReview"
                 class="million-read-article-detail-comment-bar"
                 :class="{ 'ym-in-app': isAppWebView }"
                 :z-index="2"
      >
        <form class="comment-form">
          <ym-field class="comment-input"
                    ref="millionReadArticleDetailComment"
                    v-model="content"
                    model="small-round"
                    v-focus="focus"
                    :placeholder="placeholder"
                    @blur="handleResetComment"
          >
            <template #button>
              <ym-button class="comment-btn"
                         type="primary"
                         round
                         :disabled="disabled"
                         @click.prevent="handleSendComment"
              >
                发送
              </ym-button>
            </template>
          </ym-field>
        </form>
      </ym-tabbar>
    </template>
  </bottom-bar-layout>
</template>

<script>
  import {
    Loadmore,
    Tabbar,
    Field,
    Button,
  } from '@ymba/ym-ui';
  import BottomBarLayout from '@/layout/BottomBarLayout';
  import RichText from '@/components/RichText';
  import ConsultBar from '@/pages/Topic/components/ConsultBar';
  import EmptyPage from '@/components/EmptyPage';
  import {
    getMillionReadArticleDetail,
    getReviewExplore,
    reviewCreate,
    reviewLike,
  } from '@/services/user';
  import getTopicDetail from '@/services/topic';
  import { getArticleDetail } from '@/services/article';
  import { LIMIT } from '@/utils/constant';
  import validator from '@/utils/validator';
  import { formatTime, isAppWebView, projectJump } from '@/utils';

  export default {
    name: 'MillionReadArticleDetail',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      'ym-loadmore': Loadmore,
      'ym-button': Button,
      'ym-field': Field,
      'ym-tabbar': Tabbar,
      BottomBarLayout,
      RichText,
      ConsultBar,
      EmptyPage,
    },
    props: {
      pageType: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        loading: false,
        allLoad: false,

        loaded: false,
        article: null,
        render: {
          pageTitle: '',
        },
        review: null,
        reviewList: [],
        reviewStart: 0,

        content: '',
        placeholder: '留下你友善的想法～',
        replyId: 0,
        disabled: true,
        focus: false,
        isAppWebView: isAppWebView(),
      };
    },
    computed: {
      articleId() {
        return this.$route.params.id;
      },
    },
    watch: {
      content(val) {
        this.disabled = val === '';
      },
    },
    methods: {
      fetchYear(timestamp) {
        const year = parseInt(formatTime(timestamp, 'yyyy'), 10);
        const currYear = new Date().getFullYear();
        return year === currYear;
      },
      async fetchData(id) {
        let data = {};
        if (this.pageType === 'millionReadArticle') {
          data = await getMillionReadArticleDetail(id);
        }
        if (this.pageType === 'article') {
          data = await getArticleDetail(id);
        }
        if (this.pageType === 'topic') {
          data = await getTopicDetail(id);
        }
        this.article = data.article;
        this.render = data.render;
        this.review = data.review;
        this.reviewList = this.review.list;
        this.reviewStart = this.review.start;
        this.loaded = true;
      },
      async fetchReviewExplore() {
        if (this.allLoad) return;
        const params = {
          articleId: this.$route.params.id,
          start: this.reviewStart,
          limit: LIMIT,
          requestTime: this.review.requestTime,
        };
        this.loading = true;
        const data = await getReviewExplore(params);
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.reviewList = [...this.reviewList, ...data.list];
        this.reviewStart = data.start;
        this.loading = false;
      },
      handleToUserCenter(id) {
        projectJump({
          name: 'MillionReadUserCenter',
          query: {
            userId: id,
          },
        });
      },
      async handleSendComment() {
        if (validator.isEmpty(this.content)) {
          this.$toast('请填写内容');
          return;
        }
        this.$emit('comment', this.content);
        const data = await reviewCreate(this.replyId, this.content, this.$route.params.id);
        this.allLoad = this.review.list.length === 0;
        this.reviewList = [data, ...this.reviewList];
        this.content = '';
        this.replyId = 0;
        this.placeholder = '留下你友善的想法～';
      },
      async handleLikeComment(item, type) {
        const id = type === 'quote' ? item.quote.id : item.id;
        const liked = type === 'quote' ? item.quote.like.liked : item.like.liked;
        const action = liked ? 'unlike' : 'like';
        await reviewLike(id, action);
        const index = this.reviewList.findIndex(i => i.id === item.id);
        if (type === 'quote') {
          this.reviewList[index].quote.like.liked = !liked;
          if (liked) {
            this.reviewList[index].quote.like.count -= 1;
          } else {
            this.reviewList[index].quote.like.count += 1;
          }
          return;
        }
        this.reviewList[index].like.liked = !liked;
        if (liked) {
          this.reviewList[index].like.count -= 1;
        } else {
          this.reviewList[index].like.count += 1;
        }
      },
      handleReplyComment(item) {
        this.content = '';
        this.placeholder = `回复${item.user.name}：`;
        this.replyId = item.id;
        this.focus = true;
      },
      handleResetComment() {
        if (this.content) return;
        this.placeholder = '留下你友善的想法～';
        this.replyId = 0;
      },
    },
    created() {
      this.fetchData(this.$route.params.id);
    },
    beforeRouteUpdate(to, from, next) {
      this.fetchData(to.params.id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-article-detail {
    box-sizing: border-box;
    min-height: 100%;
    background: @color-white;
    &-container {
      &.article-detail {
        padding: @size-base;
      }
    }
    &-title {
      box-sizing: border-box;
      margin-bottom: @size-extra-small;
      padding-top: @size-medium;
      font-size: @font-size-medium;
      font-weight: @font-weight-primary;
      color: @color-text-base;
      line-height: 1.4;
    }
    &-date {
      box-sizing: border-box;
      margin-bottom: @size-medium;
      padding-left: @size-base;
      font-size: @font-size-small;
      color: @color-text-lighter;
    }
    &-content {
      box-sizing: border-box;
      padding-bottom: @size-medium;
    }
    &-review {
      border-top: 10px solid #eee;
      .empty-page {
        min-height: 600px;
        /deep/ .header {
          padding-top: 0;
        }
      }
      &-header {
        box-sizing: border-box;
        padding: @size-medium @size-base;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-title {
          color: @color-text-base;
          font-size: @font-size-medium;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
        &-action {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #aaa;
          font-size: @font-size-base;
          line-height: 1;
          .icon {
            margin-right: @size-extra-small;
          }
        }
      }
      &-list {
        min-height: 600px;
        box-sizing: border-box;
        padding: @size-medium @size-base;
        &-item {
          &-container {
            box-sizing: border-box;
            padding: @size-medium 0;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            &:not(:last-child) {
              border-bottom: 1px solid #eee;
            }
          }
          &-header {
            display: flex;
            align-items: center;
            margin-bottom: 16px;
          }
          &-avatar {
            flex-shrink: 0;
            width: 70px;
            height: 70px;
            margin-right: 16px;
            border-radius: 50%;
            border: 1px solid #f5f6f7;
          }
          &-info {
            width: 100%;
          }
          &-user-name {
            margin-bottom: 16px;
            display: flex;
            align-items: flex-end;
            color: @color-text-light;
            font-size: @font-size-small;
            line-height: 1;
            .vip-icon {
              width: 24px;
              height: 24px;
              margin-left: 8px;
            }
          }
          &-quote-container {
            flex: 1;
            margin: 32px 0 16px;
            padding: 16px 32px 22px;
            border-radius: 8px;
            background: #f5f6f7;
            color: @color-text-lighter;
            font-size: @font-size-small;
            line-height: 1.5;
            span {
              color: @color-text-light;
              font-size: @font-size-small;
              font-weight: @font-weight-bold;
            }
          }
          &-content {
            flex: 1;
            margin-bottom: 16px;
            color: @color-text-base;
            font-size: @font-size-base;
            line-height: 1.5;
          }
          &-action-bar {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &-date {
              color: @color-text-lighter;
              font-size: @font-size-small;
              line-height: 1;
            }
            .right-block {
              display: flex;
              align-items: center;
            }
            .like-block {
              display: flex;
              align-items: center;
              justify-content: center;
              word-break: keep-all;
              .icon {
                font-size: 28px;
                color: #979797;
                &.active {
                  color: #02cccc;
                }
              }
              .count {
                margin-left: 8px;
                color: @color-text-lighter;
                font-size: 26px;
                line-height: 1;
              }
            }
            .comment-icon {
              color: #979797;
              margin-left: @size-medium;
              font-size: 30px;
            }
          }
        }
      }
    }
    &-comment-bar {
      box-sizing: border-box;
      z-index: @z-index-large;
      height: @tabbar-comment-height;
      padding: @size-small +  @size-extra-small  / 2 @size-base;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: @color-white;
      .comment-form {
        flex: 1;
      }
      .comment-btn {
        color: @color-white;
        background: #02cccc;
        border: none;
      }
    }
  }

</style>
